/**
 * Per-app visibility/editability for ProductEditView.
 *
 * Product keys: title, subtitle, composer, arranger, lyricist, artist, description
 *
 * SKU keys: productLine, format, style, voicing, grade, listPrice, minimumOrderQuantity,
 *           pubId, upc, isbn, ean, youtubeUrl, webStatus
 */

function rule(visible, editable) {
  return { visible, editable };
}

function allProductEditable() {
  return {
    title: rule(true, true),
    subtitle: rule(true, true),
    composer: rule(true, true),
    arranger: rule(true, true),
    lyricist: rule(true, true),
    artist: rule(true, true),
    description: rule(true, true),
  };
}

function allSkuEditable() {
  return {
    productLine: rule(true, false),
    format: rule(true, true),
    style: rule(true, true),
    voicing: rule(true, true),
    grade: rule(true, true),
    listPrice: rule(true, true),
    minimumOrderQuantity: rule(true, true),
    pubId: rule(true, true),
    upc: rule(true, true),
    isbn: rule(true, true),
    ean: rule(true, true),
    youtubeUrl: rule(true, true),
    webStatus: rule(true, true),
  };
}

/** Publisher Portal: full product editor; web status is managed outside this UI. */
export function publisherPortalProductEditFieldConfig() {
  const sku = { ...allSkuEditable(), webStatus: rule(false, false) };
  return {
    product: allProductEditable(),
    sku,
  };
}

/** My Score: same field set as the publisher portal except artist is hidden (still sent on PUT). */
export function myScoreProductEditFieldConfig() {
  const product = { ...allProductEditable(), artist: rule(false, false) };
  return {
    product,
    sku: allSkuEditable(),
  };
}
